<div class="top-bar-right">
  <div class="" global-search></div>
  <i class="material-icons" style="margin-right: 20px;" (click)="logout()">power_settings_new</i>
</div>

<div *ngIf="showReconnecting" class="success callout update-bars" data-closable="slide-out-right" [ngClass]="isSideMenuExpanded? '': 'add-left-margin'">
  <div>Reconnecting...</div>
</div>
